import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_EXIST_CHANGE_ORDERS } from "../queries/GetProductFamilies";

const fetchChangeOrderToday = async ({ queryKey }) => {
  const [, { token }] = queryKey;

  if (!token) throw new Error("Token not available");

  try {
    const response = await axios.get(
      `/getChangeOrdToday`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data || "Error fetching data");
  }
};

export const useGetChangeOrderToday = (token) => {
  return useQuery({
    queryKey: [GET_EXIST_CHANGE_ORDERS, { token }],
    queryFn: fetchChangeOrderToday,
    enabled: !!token,
    retry: false,
  });
};
